import { environment } from '@environments/environment';
import { RegionAvailable } from '@shared/services/language/registry';

export const envConfiguredHostname = (region: RegionAvailable) => environment.domains[region].hostname;
